<Dialog :id="editActorModal" :header="title" v-model:visible="visibleModel" :modal="true">
    <form id="edit-actor-form">
        <aeg-address-form v-model:address="billingAddress" :read-only="false" @validated="addressValidated"/>
    </form>
    <template v-slot:footer>
        <Button :disabled="invalidForm || isSavingActorDetails" @click.prevent="handleFormSubmit">
            Wijzigingen opslaan
        </Button>&nbsp;
        <aeg-cancel-button @click="onCloseModal" />
    </template>
</Dialog>
